import router from './router'
import store from './store'

import { getToken } from './utils/auth' // get token from cookie

const whiteList = ['/login'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title
  // determine whether the user has logged in
  const hasToken = getToken()
  if (hasToken) {
    /* 如果有token to.path是'/login' 重定向到首页 */
    if (to.path === '/login') {
        next({ path: '/' })
    } else {
        await store.dispatch('user/getInfo')
        next();
    }
  } else {
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
    }
  }
});

